import React, { useState } from "react"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import { Link } from "react-router-dom"

// users
import { useSelector } from "react-redux"
import ChangePassowrd from "./ChangePassowrd"
import { useLogout } from "hooks/useLogout"
import UpdateProfileSteps from "./updateProfileSteps"
import { usePermission } from "hooks/usePermission"
import { getAbbreviation } from "helpers/common"

const ProfileMenu = (props) => {
  const [open, setOpen] = useState(false)
  const [profileOpen, setProfileOpen] = useState(false)
  const [menu, setMenu] = useState(false)
  const { user, userType } = useSelector((state) => state.user)
  const logout = useLogout()
  const { hasPermission } = usePermission()

  const canAccess = (per) => {
    if (userType === "INVESTOR" && !hasPermission(per)) {
      return false
    }

    return true
  }

  const canDelete = () => {
    if (userType === "INVESTOR" && user.user_type === "SUB_INVESTOR") {
      return false
    }

    return true
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {user?.avatar_url ? (
            <img
              className="rounded-circle header-profile-user"
              src={user?.avatar_url}
              alt=""
            />
          ) : (
            <div
              style={{
                width: "36px",
                height: "36px",
                backgroundColor: "#f8f9fa",
                padding: "3px",
                borderRadius: "50%",
                color: "#000",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {getAbbreviation(
                user.user_type === "SUB_INVESTOR" ? user?.uname : user?.name
              )}
            </div>
          )}
          <span
            className="d-none d-xl-inline-block ms-2 me-1"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px",
            }}
            title={user.user_type === "SUB_INVESTOR" ? user?.uname : user?.name}
          >
            {user.user_type === "SUB_INVESTOR" ? user?.uname : user?.name}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem>
            <Link
              style={{
                display: "flex",
                alignItems: "center",
                color: "#495057",
                padding: "5px 0",
              }}
              to={
                userType === "ADMIN"
                  ? "/platform-manager/system-configuration"
                  : "/profile"
              }
            >
              <span
                className="icon-account-circle me-1"
                style={{ fontSize: "18px" }}
              ></span>
              Profile
            </Link>
          </DropdownItem>
          <DropdownItem>
            <p
              style={{
                display: "flex",
                alignItems: "center",
                color: "#495057",
                padding: "5px 0",
                margin: "0",
              }}
              onClick={() => setOpen(true)}
            >
              <span
                className="icon-kyc-details me-1"
                style={{ fontSize: "18px" }}
              ></span>
              Change Password
            </p>
          </DropdownItem>
          {
            // userType === "INVESTOR" &&
            user.status === "APPROVED" && (
              <>
                {canAccess("PROFILE_UPDATE") && (
                  <DropdownItem>
                    <Link
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#495057",
                        padding: "5px 0",
                      }}
                      to={"/dashboard"}
                      onClick={() => setProfileOpen(true)}
                    >
                      <span
                        className="icon-update-profile me-1"
                        style={{ fontSize: "18px" }}
                      ></span>
                      Update Profile
                    </Link>
                  </DropdownItem>
                )}
                {canDelete() && (
                  <DropdownItem>
                    <Link
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#495057",
                        padding: "5px 0",
                      }}
                      to={"/profile/delete"}
                    >
                      <span
                        className="icon-delete-account me-1"
                        style={{ fontSize: "18px" }}
                      ></span>
                      Delete Account
                    </Link>
                  </DropdownItem>
                )}
              </>
            )
          }
          <div className="dropdown-divider" />
          <Link
            style={{ display: "flex", alignItems: "center" }}
            to="#"
            onClick={logout}
            className="dropdown-item"
          >
            <span
              className="icon-logout-icon me-1"
              style={{ fontSize: "16px" }}
            ></span>
            {/* <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" /> */}
            <span>Logout</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      <ChangePassowrd open={open} setOpen={setOpen} />
      <UpdateProfileSteps open={profileOpen} setOpen={setProfileOpen} />
    </React.Fragment>
  )
}

export default ProfileMenu
